<template>
    <div>
        <div class="score-history__item" v-if="item.amount > 0">
            <div class="column"><div class="write-on">{{item.transactionMeta.label}}</div></div>
            <div class="column">{{ item.createdAt }}</div>
            <div class="column">{{ item.userFullName }}</div>
            <div class="column"><div class="write-on-amount">{{ (item.amount * item.transactionMeta.sign).toFixed(2) }}</div></div>
            <div class="column">{{ item.currentAmount }}</div>
            <div class="column"><span>Продукт:</span> Оплата штрафу({{item.protocol}})</div>
            <div class="column"></div>
            <div class="column" ><span>Джерело:</span>{{item.transactionMeta.source}}</div>
<!--            <div class="column"><span>ID транзакції:</span> {{ item.id }}</div>-->
        </div>
    </div>
</template>

<script>
export default {
    name: 'RowBlockPaymentPenalty',
    props: {
        item: {
            type: Object,
            default: () => {
                return {
                    id: null,
                    amount: null,
                    createdAt: null,
                    currentAmount: null,
                };
            },
        },
    },
}
</script>
